export const isDealerInitiatedOffer = offerSourceId => {
    return offerSourceId == 5 || offerSourceId == 16 || offerSourceId == 9;
}